angular.module('impactx.controlstructure').controller('CTRLBCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    CTRLBCtrl
]);

function CTRLBCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/ctrlb/view";
    $scope.endPointSave = "/control/ctrlb/save";
    $scope.endPointDelete = "/control/ctrlb/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.ctrlb.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.ctrlb.readOnly && !$scope.data.ctrlb.deprecated;
    }
}